module.exports = __webpack_public_path__ + "img/bg1.ae5e41f1.png";